import React from 'react';
import { useApi } from '../../../state/ApiContext';
import { useCache } from '../../../state/CachingContext';
import MessageBox from './MessageBox';

const InvitationMessageBox = (): JSX.Element => {
  const { getRequest } = useApi();
  const { getCache } = useCache();

  const [companyData, setCompanyData] = React.useState<Record<string, unknown> | undefined>(undefined);
  const [isLoading, setIsLoading] = React.useState(false);

  const invitationguid = getCache('invitationguid');

  const bootstrapAsync = async (invitationGuid: string): Promise<void> => {
    await getRequest<{ data: React.SetStateAction<Record<string, unknown> | undefined> }>(
      'Invitation/OrganisationDetails',
      [{ name: 'invitationGuid', value: encodeURIComponent(invitationGuid) }],
      setIsLoading,
    ).then((result) => {
      if (result.data) {
        setCompanyData(result.data);
      }
    });
  };

  React.useEffect(() => {
    if (invitationguid) bootstrapAsync(invitationguid);
  }, []);

  return (
    <MessageBox linkBox text={companyData ? (companyData.name as string) : 'Invalid iGuid'} isLoading={isLoading} />
  );
};

export default InvitationMessageBox;
